import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import FondoHeader from "../../..//media/img/home/grupo-de-personas-diversas-que-tienen-una-reunion-de-negocios.jpg"

import "./headerHome.scss"

const HeaderHome = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });



        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    return (
        <div>
            <div className="main-content__header">
                <div className="main-content__img-container">
                    <img className="main-content__img" src={FondoHeader} alt="" />
                </div>
                <div className="main-content__lineatop"></div>
                <div className="main-content__lineabottom"></div>
                <div className='main-content__text'>
                    <div>
                        <h1 className="header-title__main-page">{t("home.hero.title")}</h1>
                    </div>
                    <div
                        ref={el => lineRefs.current[0] = el}
                        className="content__title-line"
                    />
                    <div>
                        <p className="header-subtitle__main-page">{t("home.hero.subtitle")}</p>
                    </div>
                    <div >
                        <p className="header-text__main-page">
                            {t("home.hero.description")}
                        </p>
                    </div>
                    <a href="/Contacto" className='content__button header-button__main-page'>
                        {t("home.hero.contactButton")}
                    </a>
                </div>
                <div />
            </div>
        </div>
    )
}

export default HeaderHome